import React from "react"
import { Container } from "react-bootstrap"
import Nav from "../../containers/Nav"
import Sidebar from "./Sidebar/Sidebar"

const MainContainer = ({
    children,
    fluid,
    mainContainerClasses,
    isAuthed
}: {
    children: any
    fluid: boolean
    mainContainerClasses: string
    isAuthed: boolean
}) => {
    const extraClasses = isAuthed ? "pl-0 pr-0 home_content" : "login"
    return (
        <>
            {isAuthed && <Sidebar />}
            <Container fluid={fluid} className={`${mainContainerClasses} ${extraClasses}`}>
                {isAuthed && <Nav />}
                {children}
            </Container>
        </>
    )
}

export default MainContainer
